import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class MeetingsService {
  constructor(private api: ApiService) {}

  getMeetings(page: number, limit = 10, search = '', status = ''): Observable<any> {
    return this.api.post('/api/communication/meetings/list', {
      page,
      limit,
      search: search || null,
      status: status || null,
    });
  }

  getMeetingById(id: number): Observable<any> {
    return this.api.get(`/api/communication/meetings/${id}`);
  }

  createMeeting(formData: FormData): Observable<any> {
    return this.api.post('/api/communication/meetings', formData);
  }

  updateMeeting(id: number, formData: FormData): Observable<any> {
    return this.api.put(`/api/communication/meetings/${id}`, formData);
  }

  setStatus(id: number, status: 'ACTI' | 'INAC' | 'ARCH'): Observable<any> {
    return this.api.patch(`/api/communication/meetings/${id}/status`, { status });
  }

  deleteMeeting(id: number): Observable<any> {
    return this.api.delete(`/api/communication/meetings/${id}`);
  }
}
